import { render } from "./company-panel--entrepreneur.vue?vue&type=template&id=23041337&scoped=true&ts=true"
import script from "./company-panel--entrepreneur.vue?vue&type=script&lang=ts"
export * from "./company-panel--entrepreneur.vue?vue&type=script&lang=ts"

import "./company-panel--entrepreneur.vue?vue&type=style&index=0&id=23041337&lang=scss&scoped=true"
import "./company-panel--entrepreneur.vue?vue&type=style&index=1&id=23041337&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23041337"]])

export default __exports__